import React, { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { X, Mail, Sparkles } from 'lucide-react';

const NewsletterPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Mostrar popup depois de 2 segundos
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubscribe = () => {
    window.open('https://luisaleituras.beehiiv.com/subscribe', '_blank');
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full mx-auto bg-white border-sage-200 shadow-2xl">
        <CardContent className="p-0">
          {/* Header with close button */}
          <div className="relative bg-gradient-to-br from-sage-100 to-rose-100 p-6 rounded-t-lg">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleClose}
              className="absolute top-4 right-4 text-sage-600 hover:text-sage-800"
            >
              <X size={20} />
            </Button>
            
            <div className="text-center">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/70 backdrop-blur-sm rounded-full border border-sage-200 mb-4">
                <Sparkles className="text-rose-500" size={16} />
                <span className="text-sage-700 text-sm font-medium">Newsletter</span>
              </div>
              
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-rose-500 rounded-full">
                  <Mail className="text-white" size={24} />
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-sage-800 mb-2">
                Fique por dentro!
              </h3>
              <p className="text-sage-600">
                Receba novidades sobre lançamentos, bastidores da escrita e conteúdo exclusivo sobre literatura sáfica.
              </p>
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="space-y-4 mb-6">
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-rose-400 rounded-full"></div>
                <span className="text-sage-700 text-sm">Novidades sobre meus livros</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-sage-400 rounded-full"></div>
                <span className="text-sage-700 text-sm">Bastidores do processo criativo</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-rose-400 rounded-full"></div>
                <span className="text-sage-700 text-sm">Conteúdo exclusivo sobre literatura</span>
              </div>
            </div>

            <div className="flex gap-3">
              <Button
                onClick={handleSubscribe}
                className="flex-1 bg-rose-500 hover:bg-rose-600 text-white"
              >
                <Mail className="mr-2" size={16} />
                Assinar Newsletter
              </Button>
              <Button
                variant="outline"
                onClick={handleClose}
                className="border-sage-300 text-sage-700 hover:bg-sage-50"
              >
                Depois
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NewsletterPopup;